// extracted by mini-css-extract-plugin
module.exports = {"root":"Dot_root__34MuO"};